// Module
var code = `<template>
  <require from="./number-field.scss"></require>
  <mdc-text-field readonly.bind="readonly" blur.trigger="updateValue()" ref="input" disabled.bind="disabled" inputmask="options.bind: options; value.two-way: valueString" label.bind="label">
    <button mdc-icon-button mdc-text-field-icon trailing tabindex="0" if.bind="icon" click.trigger="iconButtonClicked() & stopPropagation" icon.bind="icon"></button>
  </mdc-text-field>
  <mdc-text-field-helper-line></mdc-text-field-helper-line>
</template>
`;
// Exports
export default code;